(function () {
  /** Close mobile header drawer when a real link inside #menu-drawer is used (Dawn does not always close on in-page / hash navigation). */
  function odxCloseHeaderMenuDrawer() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details || !details.hasAttribute('open')) return;
    var summary = details.querySelector('summary');
    if (summary) summary.click();
  }
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var drawer = document.getElementById('menu-drawer');
      if (!drawer || !drawer.contains(a)) return;
      var href = (a.getAttribute('href') || '').trim();
      if (!href || href === '#') return;
      if (/^javascript:/i.test(href)) return;
      odxCloseHeaderMenuDrawer();
    },
    true,
  );

  window.odxCloseHeaderMenuDrawer = odxCloseHeaderMenuDrawer;
})();

